import { AlertTriangle } from 'lucide-react';

export default function TraitAssignmentBanner({ count, onClick }) {
  if (count === 0) return null;

  return (
    <div className="bg-amber-900/20 border border-amber-900/50 rounded-lg p-4 mb-6">
      <div className="flex items-start gap-3">
        <AlertTriangle className="w-5 h-5 text-amber-500 flex-shrink-0 mt-0.5" />
        <div className="flex-1">
          <h3 className="font-cinzel text-amber-400 font-semibold">
            Action Required: Assign Traits to Your Fighters
          </h3>
          <p className="text-sm text-zinc-300 mt-1">
            {count} {count === 1 ? 'gladiator needs' : 'gladiators need'} permanent traits assigned.
            These traits will enhance their combat abilities.
          </p>
          <button
            onClick={onClick}
            className="mt-3 px-4 py-2 bg-amber-600 text-zinc-900 text-sm font-semibold hover:bg-amber-500 rounded transition-colors"
          >
            Assign Traits Now
          </button>
        </div>
      </div>
    </div>
  );
}
